import { Shadows } from '@material-ui/core/styles/shadows';

import { palette } from '../palette';

export enum Shadow {
  None = 'none',
  Right = 'right',
  Bottom = 'bottom',
  BottomHover = 'bottomHover',
  BottomMenu = 'bottomMenu',
}

export const shadows: Shadows = [
  'none',
  `10px 0px 20px ${palette.divider}`,
  `0px 10px 20px ${palette.divider}`,
  `0px 15px 30px ${palette.divider}`,
  `0px 5px 20px ${palette.divider}`,
  // Values below are inserted to satisfy MUI requirement of 25 shadow values
  `0px 5px 20px ${palette.divider}`,
  `0px 5px 20px ${palette.divider}`,
  `0px 5px 20px ${palette.divider}`,
  `0px 5px 20px ${palette.divider}`,
  `0px 5px 20px ${palette.divider}`,
  `0px 5px 20px ${palette.divider}`,
  `0px 5px 20px ${palette.divider}`,
  `0px 5px 20px ${palette.divider}`,
  `0px 5px 20px ${palette.divider}`,
  `0px 5px 20px ${palette.divider}`,
  `0px 5px 20px ${palette.divider}`,
  `0px 5px 20px ${palette.divider}`,
  `0px 5px 20px ${palette.divider}`,
  `0px 5px 20px ${palette.divider}`,
  `0px 5px 20px ${palette.divider}`,
  `0px 5px 20px ${palette.divider}`,
  `0px 5px 20px ${palette.divider}`,
  `0px 5px 20px ${palette.divider}`,
  `0px 5px 20px ${palette.divider}`,
  `0px 5px 20px ${palette.divider}`,
];

export default shadows;
